import { __ } from "@wordpress/i18n";
import * as Yup from "yup";
import { MAC_ES_OPTIONS } from "./FormConfig.tsx";
import { validationsLocale } from "./ValidationsLocale";

/**
 * Configure the Yup validation locale for standardized validation messages.
 */
Yup.setLocale(validationsLocale);

const MESSAGES = {
  required: __("Este campo é de preenchimento obrigatório.", "df-simulators"),
  positive: __("O valor inserido deve ser um número positivo.", "df-simulators"),
  integer: __("O valor inserido deve ser um número inteiro.", "df-simulators"),
  oneOf: __("O valor selecionado é inválido.", "df-simulators"),
  expensesExceedIncome: __(
    "As despesas mensais com créditos não podem ser superiores ao rendimento mensal líquido.",
    "df-simulators",
  ),
};

const MIN_LOAN_TERM_YEARS = 1;
const MAX_LOAN_TERM_YEARS = 40;

/**
 * Validation schema for the `mac_es` form.
 */
export const validations: Record<string, Yup.ObjectSchema<any>> = {
  mac_es: Yup.object().shape({
    region: Yup.string()
      .oneOf(MAC_ES_OPTIONS.region.map((option) => option.value), MESSAGES.oneOf)
      .required(MESSAGES.required),
    propertyCondition: Yup.string()
      .oneOf(MAC_ES_OPTIONS.propertyCondition.map((option) => option.value), MESSAGES.oneOf)
      .required(MESSAGES.required),
    /*customerAge: Yup.number()
      .integer(MESSAGES.integer)
      .positive(MESSAGES.positive)
      .required(MESSAGES.required),*/
    monthlyNetIncome: Yup.number()
      .positive(MESSAGES.positive)
      .required(MESSAGES.required),
    monthlyLoanExpenses: Yup.number()
      .min(0)
      .required(MESSAGES.required)
      .test(
        "expenses-not-exceed-income",
        MESSAGES.expensesExceedIncome,
        function (value) {
          const { monthlyNetIncome } = this.parent;
          if (monthlyNetIncome === undefined || value === undefined) return true;
          return value <= monthlyNetIncome;
        },
      ),
    equityDownAmount: Yup.number()
      .min(10000, __("O valor mínimo de entrada é 10.000€.", "df-simulators"))
      .max(1000000)
      .required(MESSAGES.required),
    loanTermInYears: Yup.number()
      .integer(MESSAGES.integer)
      .min(MIN_LOAN_TERM_YEARS)
      .max(MAX_LOAN_TERM_YEARS)
      .required(MESSAGES.required),
    rateType: Yup.string()
      .oneOf(MAC_ES_OPTIONS.rateType.map((option) => option.value), MESSAGES.oneOf)
      .required(MESSAGES.required),
  }),
};
